// src/UserProfileForm.js ver 01 from ver 00
// ============ changes from ver 00 ============
// Receive 404 error thrown as status from apiClient into userProfile and tenantProfileForms. 
// ======================
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './App'; // Assuming useAuth is exported from App.js

import * as userService from './api/userService'; // Import the new user service
import { ApiError } from './api/apiClient'; // NEW Ver 01: Import ApiError

const initialProfileState = {
    AuthLoginName: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    GovtIdType: '',
    GovtIdSerialNumber: '',
    Nationality: '',
    BirthPlace: '',
    BirthDate: '',
};

function UserProfileForm() {
    const auth = useAuth();
    const navigate = useNavigate();

    const [profile, setProfile] = useState(initialProfileState);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isExistingProfile, setIsExistingProfile] = useState(false);
    const [profileDocId, setProfileDocId] = useState(null); // Firestore document ID for update

    const userEmail = auth.user?.email;

    useEffect(() => {
        const fetchProfile = async () => {
            if (!userEmail || !auth.user) {
                setError("No authenticated user email found.");
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication token not available.");
                    setLoading(false);
                    return;
                }

                const data = await userService.getUserProfile(userEmail, token);
                if (data && data.id) { // Profile found
                    setProfile(data);
                    setProfileDocId(data.id);
                    setIsExistingProfile(true);
                } else { // Profile not found, prepare for new entry
                    setProfile(prev => ({ ...prev, AuthLoginName: userEmail }));
                    setIsExistingProfile(false);
                }
            } catch (err) {
                // if (err.message.includes('404')) { // NEW Ver 01: Replaced by below
                if (err instanceof ApiError && err.status === 404) { // NEW Ver 01: Replaces above 
                // if (err instanceof ApiError && err.status === 404) { // NEW Ver 01: Replaces above
                    setProfile(prev => ({ ...prev, AuthLoginName: userEmail }));
                    setIsExistingProfile(false);
                    console.log("User profile not found, preparing to create new one.");
                } else {
                    console.error("Error fetching user profile:", err);
                    setError(`Failed to load profile: ${err.message}`);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, [userEmail, auth]); // Re-fetch if userEmail changes

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        if (!userEmail) {
            setError("Cannot save profile: User email not available.");
            return;
        }
        if (!profile.FirstName || !profile.LastName) {
            setError("First Name and Last Name are required.");
            return;
        }

        try {
            const token = await auth.getIdToken();
            if (!token) {
                setError("Authentication token not available.");
                return;
            }

            // Ensure AuthLoginName is correct before sending
            const payload = { ...profile, AuthLoginName: userEmail };

            if (isExistingProfile && profileDocId) {
                await userService.updateUserProfile(profileDocId, payload, token);
                alert("Profile updated successfully!");
            } else {
                await userService.addUserProfile(payload, token);
                alert("Profile created successfully!");
                // Optionally refetch to get the new doc ID, or navigate away
            }
            navigate('/inventory'); // Navigate back to inventory after saving
        } catch (err) {
            console.error("Error saving user profile:", err);
            setError(`Failed to save profile: ${err.message}`);
        }
    };

    if (loading) return <p>Loading user profile...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!userEmail) return <p style={{ color: 'red' }}>Error: User must be logged in to view profile.</p>;


    return (
        <div className="container form-container">
            <h2>{isExistingProfile ? 'Edit Your Profile' : 'Create Your Profile'}</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Login Email</label>
                    <input type="email" name="AuthLoginName" value={profile.AuthLoginName} disabled />
                </div>
                <div className="form-group">
                    <label>First Name</label>
                    <input type="text" name="FirstName" value={profile.FirstName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Middle Name</label>
                    <input type="text" name="MiddleName" value={profile.MiddleName} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Last Name</label>
                    <input type="text" name="LastName" value={profile.LastName} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Government ID Type</label>
                    <input type="text" name="GovtIdType" value={profile.GovtIdType} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Government ID Serial Number</label>
                    <input type="text" name="GovtIdSerialNumber" value={profile.GovtIdSerialNumber} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Nationality</label>
                    <input type="text" name="Nationality" value={profile.Nationality} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Birth Place</label>
                    <input type="text" name="BirthPlace" value={profile.BirthPlace} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Birth Date</label>
                    <input type="date" name="BirthDate" value={profile.BirthDate} onChange={handleChange} />
                </div>
                <button type="submit">Save Profile</button>
            </form>
        </div>
    );
}

export default UserProfileForm;